import { Config } from "@/settings/Config";
import { BaseContentModel } from "@/models/BaseContentModel";
import { Tracker } from "@/utils/Tracker";
import { VariantFilter } from "@/models/VariantFilter";
import { CategoryModel } from "@/models/CategoryModel";

export class Helpers {
  private static readonly config = new Config();

  private static readonly _isMobile = {
    Android() {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry() {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS() {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera() {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows() {
      return navigator.userAgent.match(/IEMobile/i);
    },
    any() {
      return this.Android() || this.BlackBerry() || this.iOS() || this.Opera() || this.Windows();
    },
  };

  static getBrowser(): string {
    if (navigator !== undefined) {
      const s = navigator.userAgent.search("Safari"),
        c = navigator.userAgent.search("Chrome"),
        f = navigator.userAgent.search("Firefox"),
        m8 = navigator.userAgent.search("MSIE 8.0"),
        m9 = navigator.userAgent.search("MSIE 9.0");

      let browser = "";

      if (s > -1) {
        browser = "Safari";
      } else if (c > -1) {
        browser = "Chrome";
      } else if (f > -1) {
        browser = "Firefox";
      } else if (m9 > -1) {
        browser = "MSIE 9.0";
      } else if (m8 > -1) {
        browser = "MSIE 8.0";
      }
      return browser;
    }
    return "";
  }

  static mobilecheck() {
    return Helpers._isMobile.any();
  }

  static isDesktopSafari() {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("safari") !== -1) {
      return !(ua.indexOf("chrome") > -1);
    }
  }

  // If we detect mobile safari we can take the 44px browser bar into account...
  static isMobileSafari() {
    const isIphone = /(iPhone)/i.test(navigator.userAgent);
    /* eslint-disable-next-line */
    const isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    return isIphone && isSafari;
  }

  static isMicrosoftUser() {
    if (/MSIE 10/i.test(navigator.userAgent)) {
      // this is internet explorer 10
      return true;
    }

    if (/MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent)) {
      // this is internet explorer 9 and 11
      return true;
    }

    if (/Edge\/12./i.test(navigator.userAgent)) {
      // this is Microsoft Edge
      return true;
    }

    return false;
  }

  static isIE() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ");
    /* eslint-disable-next-line */
    return msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./);
  }

  static getInternetExplorerVersion(): number {
    let rv = -1,
      ua,
      re;
    if (navigator.appName == "Microsoft Internet Explorer") {
      ua = navigator.userAgent;
      re = new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})");
      if (re.exec(ua) !== null) rv = parseFloat(RegExp.$1);
    } else if (navigator.appName == "Netscape") {
      ua = navigator.userAgent;
      re = new RegExp("Trident/.*rv:([0-9]{1,}[.0-9]{0,})");
      if (re.exec(ua) !== null) rv = parseFloat(RegExp.$1);
    }
    return rv;
  }

  static setScrollBarOffset(): void {
    const $action = $(".action");
    const $logo = $("#header-logo");
    const $languageSelector = $(".language-selector");
    const $mainWrapper = $(".main-wrapper");
    // const $searchModal = $(".SearchModal");
    const $searchButton = $(".SearchButton-wrapper");
    const $printBasketButton = $(".PrintBasketButton-wrapper");
    const $feedbackForm = $(".FeedbackForm-wrapper");
    const $variantPage = $(".modal-page");
    const $loginPage = $(".login-page");
    const scrollBarWidth = Helpers.getScrollBarWidth();

    $action.css("padding-right", scrollBarWidth);
    $logo.css("padding-right", scrollBarWidth - 1);
    $languageSelector.css("padding-right", scrollBarWidth);
    $mainWrapper.css("padding-right", scrollBarWidth);
    $variantPage.css("margin-right", scrollBarWidth);
    $searchButton.css("margin-right", scrollBarWidth);
    $printBasketButton.css("margin-right", scrollBarWidth);
    $feedbackForm.css("margin-right", scrollBarWidth);
    $loginPage.css("padding-right", scrollBarWidth);
    // $searchModal.css('padding-right', scrollBarWidth)
  }

  static removeScrollBarOffset(): void {
    const $action = $(".action");
    const $logo = $("#header-logo");
    const $languageSelector = $(".language-selector");
    const $mainWrapper = $(".main-wrapper");
    // const $searchModal = $(".SearchModal");
    const $variantPage = $(".modal-page");
    const $searchButton = $(".SearchButton-wrapper");
    const $printBasketButton = $(".PrintBasketButton-wrapper");
    const $feedbackForm = $(".FeedbackForm-wrapper");
    const $loginPage = $(".login-page");

    $action.css("padding-right", "");
    $logo.css("padding-right", "");
    $languageSelector.css("padding-right", "");
    $mainWrapper.css("padding-right", "");
    $variantPage.css("margin-right", "");
    $searchButton.css("margin-right", "");
    $printBasketButton.css("margin-right", "");
    $feedbackForm.css("margin-right", "");
    $loginPage.css("padding-right", "");
    //$searchModal.css('padding-right', '')
  }

  static getScrollBarWidth(): number {
    const inner = document.createElement("p");
    inner.style.width = "100%";
    inner.style.height = "200px";

    const outer = document.createElement("div");
    outer.style.position = "absolute";
    outer.style.top = "0px";
    outer.style.left = "0px";
    outer.style.visibility = "hidden";
    outer.style.width = "200px";
    outer.style.height = "150px";
    outer.style.overflow = "hidden";
    outer.appendChild(inner);

    document.body.appendChild(outer);
    const w1 = inner.offsetWidth;
    outer.style.overflow = "scroll";
    let w2 = inner.offsetWidth;
    if (w1 == w2) w2 = outer.clientWidth;

    document.body.removeChild(outer);

    return w1 - w2;
  }

  static scrollToSubHeader(id: string) {
    if ($(`#${id}`).length) {
      const subMenu = $("#submenu");
      const offset = subMenu.length ? (subMenu.height() || 0) + 50 : 0;
      this.cancelScrollTo();
      this.scrollTo(`#${id}`, -offset, {
        //animTime: 300,
        callback() {
          Helpers.highlightSubHeader(id);
        },
      });
    }
  }

  static highlightSubHeader(id: string) {
    const $subHeader = $(`#${id} .sub-category-title:first`);
    if ($subHeader.length) {
      $subHeader.addClass("is-highlighted");
      clearTimeout($subHeader.data("highlightTimer"));
      const timer = setTimeout(() => {
        $subHeader.removeClass("is-highlighted");
      }, 1500);
      $subHeader.data("highlightTimer", timer);
    }
  }

  /* eslint-disable-next-line */
  static scrollToTop(options: any = undefined): void {
    const offset = $(".top-nav").length && $("#submenu").length ? $(".top-nav").height() : 0;
    Helpers.scrollTo("body", offset, options);
  }

  // TODO: Improve callback to include $(this) scope
  /**
   * Scrolls to a selector, and also calculates an appropriate duration from
   * the travel distance in order to create an even speed.
   * @param selector
   * @param offset
   * @param options
   */

  /* eslint-disable-next-line */
  static scrollTo(selector: string, offset: number | undefined = undefined, options: any = undefined): void {
    let opts = {
      animTime: 300, // in ms, without unit
      maxAnimTime: 1500, // in ms, without unit
      easing: "easeInOutCubic", // NOTE: jquery.easing plugin must be loaded for this to work
      /* eslint-disable-next-line */
      callback: () => {},
    };

    const _$win = $(window);

    if ($(selector).length) {
      options = options === undefined ? false : options;

      if (typeof options === "object") {
        opts = $.extend(opts, options);
      } else if (typeof options === "function") {
        // legacy support
        opts.callback = options;
      }

      const elOffset = $(selector).offset();
      const offsetTop = elOffset ? elOffset.top : 0;
      const docHeight = $(document).height() ?? 0;
      const windowHeight = $(window).height() ?? 0;

      const margin = 0,
        _offset = offset !== undefined ? offset : -130,
        avail = docHeight - windowHeight;

      let scrollPos = offsetTop + _offset - margin + 1;

      scrollPos = scrollPos === 0 ? 1 : scrollPos;

      if (scrollPos > avail) {
        scrollPos = avail;
      }

      let time = Math.ceil(Math.abs(scrollPos - (_$win.scrollTop() as number))) / 4 + opts.animTime;
      time = time <= opts.maxAnimTime ? time : opts.maxAnimTime;

      Helpers.scrollToPos(scrollPos, time, opts.callback, opts.easing);
    }
  }

  /**
   * Stops the scrollTo animation and clears queue
   */
  static cancelScrollTo() {
    if ($("body").data("scrolling")) {
      $("html, body").stop(true);
    }
  }

  /**
   * Scrolls to a an exact position
   *
   * @param pos
   * @param time
   * @param callback
   * @param easing
   */

  /* eslint-disable-next-line */
  static scrollToPos(pos: number, time: number, callback: () => any | undefined, easing: string): void {
    let arrived = false;
    let useEasing = easing || false;

    // If easing doesn't exist, disable it
    if (easing === undefined || (easing !== undefined && jQuery.easing[easing] === undefined)) {
      useEasing = false;
    }

    if (pos < 0) pos = 0;

    if (pos >= 0) {
      $("body").stop().data("scrolling", true);

      if (useEasing) {
        $("html, body").animate(
          {
            scrollTop: pos,
          },
          time,
          easing,
          function () {
            if (!arrived) {
              $("body").data("scrolling", false);
              if (callback !== undefined) {
                callback();
              }
              arrived = true;
            }
          }
        );
      } else {
        $("html, body").animate(
          {
            scrollTop: pos,
          },
          time,
          function () {
            if (!arrived) {
              $("body").data("scrolling", false);
              if (callback !== undefined) {
                callback();
              }
              arrived = true;
            }
          }
        );
      }
    }
  }

  static urlFriendlyName(val: string): string {
    // eslint-disable-next-line
    val = val.toLowerCase().replace(/[., \/#!$%\'\^&\*;:{}=\-_`~()、]/g, "-"); // replace special characters
    val = val.replace(/^-+|-+(?=-|$)/g, ""); // remove doublicate -. E.g. ---
    val = val.replace(/^-+|-+$/g, ""); // trim '-'

    return val;
  }

  static shouldShowNewsFilter(structureWeek: VariantFilter | undefined): boolean {
    if (!structureWeek) {
      return true;
    }

    return this.config.newsDeactivatedFor.indexOf(structureWeek.entry) == -1;
  }
  static categoryBreadCrumb(categoryId: string | number, categories: CategoryModel[], parentPath = "") {
    let breadCrumb = "";

    for (let i = 0; i < categories.length; i++) {
      const catUrlPath = `${this.urlFriendlyName(categories[i].title)}/`;

      if (categories[i].id === categoryId) {
        breadCrumb = `${parentPath}${catUrlPath}`;
      } else if (categories[i].nodes) {
        const subCatUrlPath = this.categoryBreadCrumb(categoryId, categories[i].nodes, catUrlPath);
        if (subCatUrlPath) {
          breadCrumb = subCatUrlPath;
        }
      }

      if (breadCrumb && breadCrumb.length > 0) {
        return breadCrumb;
      }
    }

    return "";
  }

  /**
   * Loading methods, sets body classes which triggers a
   * CSS animation (_tools/eye-liner.scss)
   */
  static loadingStart() {
    const body = document.body;
    body.classList.remove("item-open");
    body.classList.remove("item-loaded");
    body.classList.add("item-loading"); // EyeLiner -- start animation
  }

  static loadingComplete() {
    const body = document.body;
    body.classList.remove("item-loading");
    body.classList.add("item-loaded"); // EyeLiner -- complete animation
    body.classList.add("item-open"); // EyeLiner -- Fade out
  }

  static getFilteredDataProp(data: string, searchFilter = ""): string {
    if (!data || data.length === 0) {
      return data;
    }

    if (searchFilter) {
      // Return filtered and hightlighted value
      return this.getHighlightedContent(data, searchFilter, {
        elTag: "",
        emptyResults: false,
      });
    } else {
      return data;
    }
  }

  /**
   * Returns array of filters
   * @param filter - filter keyword (with spaces and quotes=
   * @param split - true/false
   * @returns Array
   */
  static getFilterKeywords(filter: string, split = true) {
    if (filter !== "") {
      filter = filter.toLowerCase();

      let keywords = [];
      const quoteValue = this.extractText(filter);

      if (quoteValue) {
        // Found value inside quote, save it, and remove that value including quotes from filter string
        keywords.push(quoteValue);
        filter = filter.replace('"' + quoteValue + '"', ""); // Remove quote from string
      } else {
        // Assume that we have an unclosed quotation, remove the single quote and move on
        filter = filter.replace('"', ""); // Remove all quotes from string
      }

      //filter = filter.replace(/["]+/g, '') // Remove all quotes from string
      //keywords = keywords.concat(filter)

      if (filter.length > 0 && split) {
        keywords = keywords.concat(filter.split(" ")); // Add the rest of the keywords if available
      } else if (filter.length) {
        keywords = keywords.concat(filter);
      }
      // Return trimmed array and remove single letter items
      return keywords.filter((item) => item.trim() !== "" && item.trim().length > 1);
    }
    return split ? [] : "";
  }

  /**
   * Extract value between quotes in string
   * @param str
   * @returns {string}
   */
  static extractText(str: string) {
    const regExp = /"([^)]+)"/;
    const matches = regExp.exec(str);
    if (matches !== null) {
      return matches[1];
    }
    return "";
  }

  /**
   * Returns paragraphs in content which contains filter
   * @param html
   * @param filter -- string with keyword(s)
   * @param options -- Object
   * @returns {string}
   */
  static getHighlightedContent(html: string, filter: string, options: any = {}): string {
    options = Object.assign(
        {
          elTag: "", // Set to 'p' to split on paragraphs, or leave empty to use whole html
          multipleHighlights: true,
          emptyResults: false, // Enabled for body text
        },
        options
    ) as any;

    if (html !== undefined) {
      const filters = this.getFilterKeywords(filter, options.multipleHighlights);

      // Our meaty highlight function
      const highlight = (key: string, content: string) => {
          // Create a regular expression that matches the key, ignoring case
          const reg = new RegExp(`(${key})(?![^<]*>|[^<>]*</)`, "gi");

        let matches = 0;

        if (key.trim() !== "") {
          // Replace all occurrences of the key with the highlighted version
          content = content.replace(reg, (match) => {
            matches++;
            return `<mark class="filter-match">${match}</mark>`;
          });
        }
        return { content, matches };
      };

      const chunks = options.elTag !== undefined ? html.split("</" + options.elTag + ">") : [html];
      let output = "",
          foundMatch = false;

      // Loop through chunks
      for (let j = 0; j < chunks.length; j++) {
        let chunkContent = this.stripTags(chunks[j]);
        if (chunkContent !== "") {
          for (let i = 0; i < filters.length; i++) {
            const result = highlight(filters[i], chunkContent);
            chunkContent = result.content;
            if (result.matches > 0) {
              foundMatch = true;
            }
          }
          if (options.elTag) {
            output +=
                "<" +
                options.elTag +
                ">" +
                chunkContent +
                "</" +
                options.elTag +
                ">";
          } else {
            output += chunkContent;
          }
        }
      }

      return (output === "" && options.emptyResults) || output !== "" ? output : html;
    }
    return html;
  }


  static stripTags(html: string) {
    return html.replace(/<(?:.|\n)*?>/gm, "");
  }

  static getFilterClass(data: BaseContentModel) {
    if (data.filtered === undefined) {
      return "";
    }

    return data.filtered ? "filtered-in" : "filtered-out";
  }

  static setPageTitle(title = ""): string {
    const appName = this.config.appName[this.config.portal];
    document.title = title && title.length > 0 ? `${title} | ${appName}` : appName;

    return document.title;
  }
  
  static groupBy<T, K extends keyof T>(collection: T[], property: K): Map<T[K], T[]> {
    const result: Map<T[K], T[]> = new Map();

    for (const item of collection) {
      const key = item[property] != null ? item[property] : "" as unknown as T[K];

      if (result.has(key)) {
        result.get(key)!.push(item);
      } else {
        result.set(key, [item]);
      }
    }

    return result;
  }

  static sortObjectArr<T>(collection: T[], propName: string, reverse = false): T[] {
    const arr = collection as unknown as { [key: string]: string | number }[];

    if (arr.length > 1) {
      return arr.sort((a, b) => {
        const aProp = typeof a[propName] === "string" ? (a[propName] as string).toLowerCase() : a[propName];
        const bProp = typeof b[propName] === "string" ? (b[propName] as string).toLowerCase() : b[propName];

        if ((aProp || aProp === 0) && (bProp || bProp === 0)) {
          if (aProp < bProp) {
            return reverse ? 1 : -1;
          } else if (aProp > bProp) {
            return reverse ? -1 : 1;
          }
        }
        return 0;
      }) as unknown as T[];
    } else {
      return collection;
    }
  }

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  static debounce(fn: (...params: any[]) => any, wait: number, immediate: boolean = false) {
    let timer: ReturnType<typeof setTimeout> | undefined = undefined;
    return function (this: any, ...args: any[]) {
      if (timer === undefined && immediate) {
        fn.apply(this, args);
      }
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), wait);
      return timer;
    };
  }

  /******************************************
   *
   * throttle
   *
   * $(window).resize( Helper.throttle(function(){}, 250 )
   *
   * @param fn
   * @param threshold - default 250
   * @param context - this
   */
  static throttle(fn: (...params: any[]) => any, threshold: number, context: any): () => any {
    threshold = threshold || (threshold = 250);
    let last, deferTimer;
    return function (...args: any[]) {
      const now = new Date().getTime();

      if (last && now < last + threshold) {
        // hold on to it
        clearTimeout(deferTimer);
        deferTimer = setTimeout(function () {
          last = now;
          fn.apply(context, args);
        }, threshold);
      } else {
        last = now;
        fn.apply(context, args);
      }
    };
  }
}
